module.exports = __webpack_public_path__ + "img/D2C.c88d0432.png";